import React, { useState, useEffect } from 'react';
import { getBlogs } from '../helpers/axios';
import LoadingLoop from './loadingLoop';
import '../styles/noticias.css';

function Noticias() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    getBlogs().then(data => {
      if (!Array.isArray(data)) throw new Error('Respuesta inválida');
      if (active) setData(data);
    }).catch(() => {
      if (active) setError(true);
    }).finally(() => {
      if (active) setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);
  if (loading) return <LoadingLoop />;
  if (error) return <p className="empty-state" role="alert">No se pudieron cargar las noticias. Intentá nuevamente más tarde.</p>;
  if (!data.length) return <p className="empty-state" role="status">Todavía no hay noticias publicadas.</p>;
  return <div className='noticias'>
        {data.map(article => <NoticiasItem key={article._id} data={article} />)}
    </div>;
}

function NoticiasItem(props) {
  const {
    img,
    type,
    tittle,
    text,
    autor,
    link
  } = props.data;
  return <article className="noticiasItem">
            <div className="noticiasItem__img"><img src={img} alt={tittle} loading="lazy" /></div>
            <div className="news-card-body"><span className="categoria">{type || 'Novedades'}</span>
                <h3 className="noticiasItem__titulo">{link ? <a href={link} target="_blank" rel="noopener noreferrer">{tittle}<span aria-hidden="true"> ↗</span></a> : tittle}</h3>
                <p className="noticiasItem__descripcion">{text}</p>
                <p className="noticiasItem__autor">{autor}</p>
            </div>
        </article>;
}

export default Noticias;
